import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName:'',  // 管理员名称
    userImg:'', // 管理员头像
    userId:'', // 管理员id

    message:'', // 聊天列表消息

    userParticularsInfo:'', // 聊天详情用户信息

  },
  mutations: {
    // 更改管理员名称
    updateUserName(state,userName){
      state.userName = userName
    },
    // 更改管理员头像
    updateUserImg(state,userImg){
      // console.log('userImg')
      // console.log(userImg)
      // console.log(state.userImg)
      state.userImg =  userImg 
    },
    // 更改管理员Id
    updateUserId(state,userId){
      state.userId =  userId 
    },
    // 更改消息列表消息
    updateMsg(state,msg){
      state.message = msg
    },
    // 更改聊天详情用户信息
    updateUerInfo(state,userInfo){
      state.userParticularsInfo = userInfo
    }
  },
  actions: {
  },
  modules: {
  }
})
